export default {
  forest_product_cooperatives: {
    name: "森林産品協同組合",
    description: "持続可能な非木材森林産品を販売するための地域協同組合を形成します。",
  },
  satellite_monitoring: {
    name: "衛星モニタリング",
    description: "衛星画像で土地利用の変化を追跡し、監視活動を支援します。",
  },
  firebreak_construction: {
    name: "防火帯の整備",
    description: "山火事の拡大を抑える物理的な防火帯を整備します。",
  },
  community_patrols: {
    name: "コミュニティ森林パトロール",
    description: "地域チームを訓練し、対象地の監視と違法伐採の報告を行います。",
  },
  youth_engagement: {
    name: "若者参加プログラム",
    description: "若者が保全活動に参加できる機会をつくります。",
  },
  agroforestry_training: {
    name: "持続可能なアグロフォレストリー研修",
    description: "農家にアグロフォレストリーと森林保全の実践を研修します。",
  },
  reforestation: {
    name: "再森林化キャンペーン",
    description: "劣化地を回復するため、在来樹種の植林を実施します。",
  },
  water_protection: {
    name: "水源保護",
    description: "プロジェクト内の河川、湧水、河畔域を保護します。",
  },
};
